var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRCicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 317.7 441.4",
    style: {
      enableBackground: "new 0 0 317.7 441.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.6,0.8c105.6,0,210.8,0,316.4,0c0,146.7,0,293.1,0,439.9c-105.3,0-210.7,0-316.4,0C0.6,294.2,0.6,147.8,0.6,0.8z  M15,426.6c96.4,0,192.1,0,287.8,0c0-137.4,0-274.5,0-411.5c-96.2,0-191.9,0-287.8,0C15,152.4,15,289.3,15,426.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,89.4c18.7,0,36.6,0,55,0c0-13.9,0-27.6,0-41.7c14.1,0,27.8,0,42.1,0c0,13.7,0,27.4,0,41.4c18.4,0,36.2,0,54.6,0 c0-13.5,0-27.2,0-41.4c14.5,0,28.4,0,42.7,0c0,30.6,0,61.1,0,92.2c-1.8,0.1-3.6,0.2-5.4,0.2c-75.2,0-150.4,0-225.7,0.1 c-4.7,0-5.8-1.4-5.7-5.9c0.2-27.1,0.1-54.2,0.1-81.3c0-1.6,0-3.3,0-5.4c14.2,0,28,0,42.4,0C82.5,61.5,82.5,75.2,82.5,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,345.7c0-14.2,0-27.9,0-42c14,0,27.7,0,41.7,0c0,30.9,0,61.7,0,92.7c-78.8,0-157.2,0-235.9,0c0-31,0-61.6,0-93 c5.3,0,10.6,0,15.8,0c7.1,0,14.3,0.3,21.4-0.1c4.3-0.2,5.3,1.4,5.2,5.4c-0.2,10.6-0.1,21.3-0.1,31.9c0,1.6,0,3.3,0,5.2 C132.2,345.7,182.5,345.7,233.4,345.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7,180.6c0,33.3,0,66.2,0,99.3c-5.8,0-11.1,0-16.8,0c0-40.7,0-81.2,0-122.4c1.9,0,3.6,0,5.4,0c67.4,0,134.9,0,202.3,0 c16.3,0,26.3,10.1,26.3,26.5c0,5.7-0.1,11.3,0,17c0.5,15.6-4.6,28.3-19.1,36.8c3.6,8.7,7.3,17.3,10.8,26.1c2,5.1,3.7,10.3,6,16.6 c-6.8,0-11.9,0.1-17-0.1c-1,0-2.2-1.4-2.7-2.4c-6.9-14.7-13.7-29.4-19.8-42.4c4.2-4.9,8.2-8.9,11.4-13.6c2-3,3.4-6.8,3.8-10.3 c0.6-5.6,0.3-11.3,0-16.9c-0.4-8-7.1-14.3-15-14.3c-57.5,0-115,0-172.4,0C60.1,180.3,59.3,180.5,57.7,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,212.1c0,17.2,0,33.8,0,51.1c1.9,0,3.9,0,5.8,0c41.9,0,83.7,0,125.6-0.1c3.3,0,5.5,0.8,7.4,3.6c3,4.3,6.4,8.4,10,13.1 c-54.9,0-109.1,0-163.7,0c0-28.2,0-56.3,0-84.9c54.3,0,108.5,0,163.8,0c-4.6,5.8-8.6,11.3-13.1,16.4c-0.9,1-3.4,0.7-5.2,0.7 c-41.4,0-82.7,0-124.1,0C90.3,212.1,88.3,212.1,85.8,212.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3,305.4c0,9.2,0,18.1,0,27.5c-12,0-24,0-36.3,0c0-9.1,0-18.1,0-27.5C113,305.4,124.9,305.4,137.3,305.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,333c0-9.3,0-18.2,0-27.5c12.1,0,24.1,0,36.4,0c0,9.1,0,18.2,0,27.5C203.3,333,191.4,333,179,333z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRCicon2);
export default __webpack_public_path__ + "static/media/RC icon2.e5e6afd387f6c8c1724f7c19b2fc5e6d.svg";
export { ForwardRef as ReactComponent };